<template>
  <div class="section section_confirmations">
    <div class="main_container step_1_form main_container_fixed">
      <div class="sub_container w-row">
        <div class="column-10 w-col w-col-3"></div>
        <div class="column-2 w-col w-col-6">
          <img src="@/assets/images/Group-11560.svg" loading="lazy" width="126" alt="" class="image-4" />
          <h1 class="heading-3" v-if="$route.query.ResponseCode === '1'">Η πληρωμή ήταν επιτυχής και δημιουργήθηκε το συμβόλαιο με αριθμό {{$route.params.id}}</h1>
          <h1 class="heading-3" v-if="$route.query.ResponseCode === '2'">Η πληρωμή δεν ολοκληρώθηκε με επιτυχία, {{$route.query.ReasonText}}</h1>
        </div>
        <div class="column-16 w-col w-col-3"></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  created() {
    console.log(this.$route.query);
    // if (!this.$route.meta.allowed) {
    //   this.$router.push({ path: `/${this.$route.params.product}` });
    // }
  },
  methods: {
  }
};
</script>
